import Vue from 'vue'
import Vuex from 'vuex'
import User from './User'
import ChangePin from './ChangePin'
import Transactions from './Transactions'
import AirTime from './AirTime'
import Electricity from './Electricity'
import Transfer from './Transfer'
import FRSC from './Frsc'
import Nis from './Nis'
import Cable from './Cable'
import jamb from './jamb'
import Internet from './Internet'


Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
    User,
    ChangePin,
    Transactions,
    AirTime,
    Electricity,
    Transfer,
    FRSC,
    Nis,
    Cable,
    jamb,
    Internet
    },
    strict: process.env.NODE_ENV !== 'production'
})